import useAuth from "hooks/UseAuth";

import { Link } from "react-router-dom";
import { Header } from "shared/components/organisms/Header/Header";
import { Sidebar } from "shared/components/organisms/Sidebar/Sidebar";
import { ProfileImage } from "shared/components/organisms/ProfileImage/ProfileImage";
import { HexIconButton } from "shared/components/molecules/HexIconButton/HexIconButton";

import { ReactComponent as LeftArrow } from 'assets/icons/left-arrow.svg'
import PersonalIcon from 'assets/img/personalDataIcon3x.png'
import LockIcon from 'assets/img/lockIcon3x.png'
import SettingsIcon from 'assets/img/settingsIcon3x.png'
import TermsIcon from 'assets/img/termsIcon3x.png'


import {
  Container, Content, Subheader, Username, AgendaContainer, ButtonsList, CalendarIcon, WalletIcon
} from "./_profile";

export const Profile = () => {
  const { user } = useAuth();

  return (
    <Container>
      <Header />
      <Sidebar />
      <Subheader>
        <Link to="/" className="profile__subheader-button">
          <LeftArrow
            className="profile__subheader-icon"
          />
        </Link>
      </Subheader>

      <Content>
        <ProfileImage />
        <Username>
          {user?.individual_person?.name}
        </Username>

        <AgendaContainer>
          <Link to="/historico"
            className="profile__agenda__button"
          >
            <CalendarIcon />
            <h1
              className="profile__agenda__button-title"
            >
              Ver meu histórico
            </h1>
          </Link>

          <Link to="/ganhos"
            className="profile__agenda__button"
          >
            <WalletIcon />
            <h1
              className="profile__agenda__button-title"
            >
              Ver meus ganhos
            </h1>
          </Link>
        </AgendaContainer>

        <ButtonsList>
          <HexIconButton
            to="/perfil-pessoal"
            icon={PersonalIcon}
            text="Meus dados pessoais"
          />
          <HexIconButton
            to="/perfil-profissional"
            icon={SettingsIcon}
            text="Meus dados profissionais"
          />
          <HexIconButton
            to="/perfil-web"
            icon={LockIcon}
            text="Alterar email e senha"
          />
          <HexIconButton
            to="/termos-de-uso"
            icon={TermsIcon}
            text="Termos de uso"
          />
        </ButtonsList>
      </Content>
    </Container>
  );
};
